import React from 'react';
import { NavLink } from 'react-router-dom';
import { Nav } from './styles';

const BackButton = ({ adress }: any) => {
  return (
    <NavLink to={adress} style={{ textDecoration: 'none' }}>
      <Nav>Voltar</Nav>
    </NavLink>
  );
};

export default BackButton;
